
const clearStorageKeys = (storage) => {
  const keysToRemove = [];
  for (let i = 0; i < storage.length; i++) {
    const key = storage.key(i);
    if (
      key &&
      (key.startsWith('astroguru_') ||
        key.startsWith('chat_') ||
        key.startsWith('user_') ||
        key.includes('astro') ||
        key.includes('guru'))
    ) {
      keysToRemove.push(key);
    }
  }
  keysToRemove.forEach((key) => storage.removeItem(key));
};

export async function logoutUser({ user, logout, endSession, setIsLoggingOut, setShowUserMenu }) {
  if (!window.confirm('Are you sure you want to logout? This will clear all your session data.')) return;

  setIsLoggingOut(true);
  setShowUserMenu && setShowUserMenu(false);
  document.body.style.cursor = 'wait';

  try {
    // Step 1: End Backend Session
    try {
      const userId = user?.userId || user?.id;
      const sessionId = localStorage.getItem('astroguru_session_id');
      if (userId && endSession) {
        await endSession(sessionId || null, userId);
      }
    } catch {}

    // Step 2: Clear storage
    clearStorageKeys(localStorage);
    clearStorageKeys(sessionStorage);

    // Step 3: Fire logout events
    window.dispatchEvent(new CustomEvent('userLoggedOut'));
    window.dispatchEvent(new CustomEvent('clearAllData'));
    window.dispatchEvent(new CustomEvent('clearChat'));

    // Step 4: Auth context logout
    if (logout) logout();

    // Step 5: Redirect
    setTimeout(() => {
      window.location.href = '/';
      window.location.reload();
    }, 100);
  } catch {
    window.location.href = '/';
    window.location.reload();
  } finally {
    document.body.style.cursor = 'default';
    setIsLoggingOut && setIsLoggingOut(false);
  }
}